import { SegmentType } from '../../../../../utils/types/JobOpenings';

interface DefaultSegment {
  skillValue: number[];
  experienceValue: number[];
}

export const DEFAULT_SEGMENTS = ({ skillValue, experienceValue }: DefaultSegment): SegmentType[][] => [
  [
    {
      id: 1,
      name: 'Top Talent',
      xAxis: skillValue[0] + (2 / 3) * (skillValue[1] - skillValue[0]),
      yAxis:
          experienceValue[0] +
          (2 / 3) * (experienceValue[1] - experienceValue[0]),
    },
    {
      xAxis: skillValue[1],
      yAxis: experienceValue[1],
    },
  ],
  [
    {
      id: 2,
      name: 'Distinguished Performer',
      xAxis: skillValue[0] + (1 / 3) * (skillValue[1] - skillValue[0]),
      yAxis:
          experienceValue[0] +
          (2 / 3) * (experienceValue[1] - experienceValue[0]),
    },
    {
      xAxis: skillValue[0] + (2 / 3) * (skillValue[1] - skillValue[0]),
      yAxis: experienceValue[1],
    },
  ],
  [
    {
      id: 3,
      name: 'Specialist',
      xAxis: skillValue[0],
      yAxis:
          experienceValue[0] +
          (2 / 3) * (experienceValue[1] - experienceValue[0]),
    },
    {
      xAxis: skillValue[0] + (1 / 3) * (skillValue[1] - skillValue[0]),
      yAxis: experienceValue[1],
    },
  ],
  [
    {
      id: 4,
      name: 'Rising Star',
      xAxis: skillValue[0] + (2 / 3) * (skillValue[1] - skillValue[0]),
      yAxis:
          experienceValue[0] +
          (1 / 3) * (experienceValue[1] - experienceValue[0]),
    },
    {
      xAxis: skillValue[1],
      yAxis:
          experienceValue[0] +
          (2 / 3) * (experienceValue[1] - experienceValue[0]),
    },
  ],
  [
    {
      id: 5,
      name: 'Solid Applicant',
      xAxis: skillValue[0] + (1 / 3) * (skillValue[1] - skillValue[0]),
      yAxis:
          experienceValue[0] +
          (1 / 3) * (experienceValue[1] - experienceValue[0]),
    },
    {
      xAxis: skillValue[0] + (2 / 3) * (skillValue[1] - skillValue[0]),
      yAxis:
          experienceValue[0] +
          (2 / 3) * (experienceValue[1] - experienceValue[0]),
    },
  ],
  [
    {
      id: 6,
      name: 'Developing Specialist',
      xAxis: skillValue[0],
      yAxis:
          experienceValue[0] +
          (1 / 3) * (experienceValue[1] - experienceValue[0]),
    },
    {
      xAxis: skillValue[0] + (1 / 3) * (skillValue[1] - skillValue[0]),
      yAxis:
          experienceValue[0] +
          (2 / 3) * (experienceValue[1] - experienceValue[0]),
    },
  ],
  [
    {
      id: 7,
      name: 'Potential Star',
      xAxis: skillValue[0] + (2 / 3) * (skillValue[1] - skillValue[0]),
      yAxis: experienceValue[0],
    },
    {
      xAxis: skillValue[1],
      yAxis:
          experienceValue[0] +
          (1 / 3) * (experienceValue[1] - experienceValue[0]),
    },
  ],
  [
    {
      id: 8,
      name: 'Emerging Talent',
      xAxis: skillValue[0] + (1 / 3) * (skillValue[1] - skillValue[0]),
      yAxis: experienceValue[0],
    },
    {
      xAxis: skillValue[0] + (2 / 3) * (skillValue[1] - skillValue[0]),
      yAxis:
          experienceValue[0] +
          (1 / 3) * (experienceValue[1] - experienceValue[0]),
    },
  ],
  [
    {
      id: 9,
      name: 'Novice',
      xAxis: skillValue[0],
      yAxis: experienceValue[0],
    },
    {
      xAxis: skillValue[0] + (1 / 3) * (skillValue[1] - skillValue[0]),
      yAxis:
          experienceValue[0] +
          (1 / 3) * (experienceValue[1] - experienceValue[0]),
    },
  ],
];
